<template>
    <div id="editor" class="col-sm-12 nopads">
        <div class="col-sm-12 editor-form" @click.stop="">
            <h2 class="editor-header px-3">
                {{ !!editInspectionTemplate ? $t('mvr_inspection.template_editor.edit_inspectable_template') : $t('mvr_inspection.template_editor.create_inspectable_template') }}
            </h2>
            <div class="col-sm-12 form-data" @click.stop="">
                <span class="span-title">{{ $t('mvr_inspection.template_editor.name') }}</span>
                <input class="form-control form-control-mb" v-model="inspectionTemplate.name" type="text"/>
                <h4 class="form-header pl-3 pr-4">{{ $t('mvr_inspection.template_editor.sections') }}</h4>
                <div class="col-sm-12 form-data">
                    <div class="row measure-section" v-for="(inspectionSection, index) in inspectionTemplate.sections"
                        v-bind:key="`${inspectionSection.id}-${index}`">
                        <div class="col-sm-12 nopads">
                            <mvr-inspection-section-editor :section="inspectionSection" :inspectables="inspectables"
                                @updateSection="(section) => updateSection(index, section)" />
                        </div>
                        <div class="col-12 nopads text-right">
                            <button class="btn btn-danger form-button" :disabled="inspectionTemplate.sections.length === 1" @click.stop="removeInspectionSection(index)">
                                {{ $t('common.remove')}}
                            </button>
                        </div>
                    </div>
                </div>
                <hr/>
                <div class="col-12 d-flex justify-content-center mt-2">
                    <button class="btn pt-1 pb-1 mx-1 btn-success btn-sm" @click.stop="addInspectionSection">
                        <i class="fa fa-plus" style="font-size: .8em; padding: 0; line-height: 1em;" />
                    </button>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 d-flex justify-content-end">
                    <button class="btn form-button btn-danger" @click.stop="$emit('close')">
                        {{ $t('common.cancel') }}
                    </button>
                    <button class="btn form-button btn-success" :disabled="loading || !isValidTemplate()"
                        @click.stop="submitTemplate">
                        {{ $t('common.save') }}
                    </button>
                </div>
            </div>
        </div>
        <div v-if="loading" id="loader" class="spinner" />
    </div>
</template>

<script>
import { restApi } from '@/components/mixins/RestApiMixin'
import MvrInspectionSectionEditor from "@/components/inspections/mvrInspections/MvrInspectionSectionEditor";
import {inject} from "vue";

export default {
    name: 'MvrInspectionTemplateEditor',
    components: {
        MvrInspectionSectionEditor
    },
    mixins: [restApi],
    props: {
        editInspectionTemplate: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            loading: false,
            inspectionTemplate: {
                name: '',
                sections: []
            },
            inspectables: []
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert')
        return { showAlert }
    },
    mounted: function () {
        if (this.editInspectionTemplate) {
            this.inspectionTemplate = this.editInspectionTemplate
        }

        if (this.inspectionTemplate.sections.length === 0) {
            this.addInspectionSection()
        }
        this.fetchInspectables()
    },
    methods: {
        fetchInspectables() {
            this.loading = true
            this.restFetch(this.mvrInspectableUrl, (response) => {
                this.inspectables = response.data
                this.loading = false
            })
        },
        addInspectionSection() {
            this.inspectionTemplate.sections.push({
                id: `EDITOR_${this.generateUUID()}`,
                section_header: '',
                inspectables: []
            })
        },
        removeInspectionSection(index) {
            this.inspectionTemplate.sections.splice(index, 1)
        },
        updateSection(index, section) {
            this.inspectionTemplate.sections.splice(index, 1, section)
        },
        submitTemplate() {
            this.loading = true

            const payloadTemplate = JSON.parse(JSON.stringify(this.inspectionTemplate))
            // Remove new section ids
            payloadTemplate.sections.forEach((section) => {
                if (`${section.id}`.startsWith('EDITOR_')) {
                    delete section.id
                }
            })
            if (payloadTemplate.id && payloadTemplate.id > 0) {
                this.restUpdate(this.mvrInspectionTemplateseUrl, payloadTemplate, () => {
                    this.loading = false
                    this.$emit('closeAndUpdate')
                    this.showAlert(this.$t('mvr_inspection.template_editor.update_success'), 'success')
                }, () => {
                    this.loading = false
                    this.showlAert(this.$t('mvr_inspection.template_editor.update_failed'))
                })
            } else {
                this.restAdd(this.mvrInspectionTemplateseUrl, payloadTemplate, () => {
                    this.loading = false
                    this.$emit('closeAndUpdate')
                    this.showAlert(this.$t('mvr_inspection.template_editor.create_success'), 'success')
                }, () => {
                    this.loading = false
                    this.showAlert(this.$t('mvr_inspection.template_editor.create_failed'))
                })
            }
        },
        isValidTemplate() {
            return this.inspectionTemplate.name.length > 0 && this.inspectionTemplate.sections.every((section) => {
                return section.section_header.length > 0 && section.inspectables.length > 0
            })
        },
        generateUUID() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                const r = Math.random() * 16 | 0,
                    v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            })
        }
    }
}
</script>
<style scoped>
.measure-section {
    padding: 1em 1em 1em 1em;
    margin-bottom: .75em;
    background-color: #FFFFFF;
    border: 1px solid #7FC000;
    border-radius: .5em;
}
</style>
